import { I18nUserDefinedConfig } from '@app/i18n/i18n-user-defined.types';
import { ServiceIdentifyType } from '@app/shared/types';
import { ENTITY_TYPES } from '@app/shared/types/enums/entityTypes.enum';

export const SUPPORT_USER_DEFINED_I18N_CONFIG: Record<
  ServiceIdentifyType,
  I18nUserDefinedConfig
> = {
  [ENTITY_TYPES.INVENTORY_ITEM_VENUE]: ['name', 'measures.[].description'],
  [ENTITY_TYPES.TRANSFER]: [
    'site_name',
    'site_name_to',
    'inventory_items.[].item_name',
    'inventory_items.[].measure_description',
  ],
  [ENTITY_TYPES.SITE]: ['name'],
  [ENTITY_TYPES.EVENTS]: ['name'],
  [ENTITY_TYPES.EVENT_TYPE]: ['name'],
};
